"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryDrawList = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var HistoryDrawList = /** @class */ (function (_super) {
    __extends(HistoryDrawList, _super);
    function HistoryDrawList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDrawDateConverted = function () {
            var drawHistoryList = new HistoryDrawList();
            if (_this.length > 0) {
                _this.forEach(function (x) {
                    x.drawDateConverted = moment_timezone_1.default(x.draw).format('MMM Do, YYYY');
                    x.startDateConverted = moment_timezone_1.default(x.start).format('MMM Do, YYYY');
                    x.endDateConverted = moment_timezone_1.default(x.end).format('MMM Do, YYYY');
                    drawHistoryList.push(x);
                });
            }
            return drawHistoryList;
        };
        return _this;
    }
    return HistoryDrawList;
}(Array));
exports.HistoryDrawList = HistoryDrawList;
//# sourceMappingURL=HistoryDrawList.js.map